import {
  Box,
  ClickAwayListener,
  InputAdornment,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  OutlinedInput,
  SvgIcon,
  Typography,
} from '@mui/material';
import SearchMdIcon from '@untitled-ui/icons-react/build/esm/SearchMd';
import PropTypes from 'prop-types';
import type { ChangeEvent, FocusEvent } from 'react';
import { forwardRef, useCallback } from 'react';
import { MessageChannel } from 'src/API';
import { Tip } from 'src/components/tip';
import { OrganizationObject } from 'src/slices/organization';
import { UserRecords } from '../team/team-table';
import { getDisplayName } from './chat-thread-item';

interface ChatSidebarSearchProps {
  isFocused?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onClickAway?: () => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onSelect?: (result: MessageChannel) => void;
  query?: string;
  results?: MessageChannel[];
  organizations: OrganizationObject[];
  userRecords: UserRecords;
}

export const ChatSidebarSearch = forwardRef<HTMLDivElement, ChatSidebarSearchProps>((props, ref) => {
  const {
    isFocused,
    onChange,
    onClickAway = () => {},
    onFocus,
    onSelect,
    query = '',
    results = [],
    userRecords,
    organizations,
    ...other
  } = props;

  const handleSelect = useCallback(
    (result: MessageChannel): void => {
      onSelect?.(result);
    },
    [onSelect],
  );

  const showTip = isFocused && !query;
  const showResults = isFocused; //&& query;
  const hasResults = results.length > 0;

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <Box ref={ref} sx={{ p: 2 }} {...other}>
        <OutlinedInput
          fullWidth
          onChange={onChange}
          onFocus={onFocus}
          placeholder="Search Threads"
          startAdornment={
            <InputAdornment position="start">
              <SvgIcon>
                <SearchMdIcon />
              </SvgIcon>
            </InputAdornment>
          }
          value={query}
        />
        {showTip && (
          <Box sx={{ py: 2 }}>
            <Tip message="Enter a thread name" />
          </Box>
        )}
        {showResults && (
          <>
            {hasResults ? (
              <Box sx={{ py: 2 }}>
                <Typography color="text.secondary" variant="subtitle2">
                  Threads
                </Typography>
                <List>
                  {results.map((thread) => {
                    let itemAvatar = <></>;
                    let text = getDisplayName(thread, userRecords, organizations);
                    // if (contact.contactType === 'ORGANIZATION') {
                    //   console.log('contact', contact)
                    //   text = contact.description || contact.name
                    // }
                    // if (contact.contactType === 'USER') {
                    //   text = contact.account?.displayName || contact.email
                    //   itemAvatar = <UserAvatar
                    //     config={contact?.account?.avatar}
                    //     sx={{
                    //       height: 32,
                    //       width: 32
                    //     }}
                    //   />
                    // }
                    return (
                      <ListItemButton key={thread.id} onClick={(): void => handleSelect(thread)}>
                        <ListItemAvatar>{itemAvatar}</ListItemAvatar>
                        <ListItemText
                          primary={text}
                          primaryTypographyProps={{
                            noWrap: true,
                            variant: 'subtitle2',
                          }}
                          secondary={'hello'}
                        />
                      </ListItemButton>
                    );
                  })}
                </List>
              </Box>
            ) : (
              <Box sx={{ py: 2 }}>
                <Typography color="text.secondary" variant="body2">
                  We couldn&apos;t find any matches for &quot;{query}&quot;. Try checking for typos or using complete
                  words.
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    </ClickAwayListener>
  );
});

ChatSidebarSearch.propTypes = {
  isFocused: PropTypes.bool,
  onChange: PropTypes.func,
  onClickAway: PropTypes.func,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  query: PropTypes.string,
  results: PropTypes.array,
};
